import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'komodo-toggle',
    templateUrl: './komodo-toggle.component.html',
    styleUrls: ['./komodo-toggle.component.scss'],
})
export class KomodoToggleComponent {

    @Input() label: string | null = null;
    @Input() checked: boolean | null = false;
    @Input() disabled: boolean | null = false;

    @Output() toggleChange:EventEmitter<CustomEvent> = new EventEmitter<CustomEvent>();

    @ViewChild('coreToggle', {
        static: true,
        read: ElementRef<HTMLButtonElement>
    }) coreToggle!: ElementRef<HTMLButtonElement>;

    constructor() {}

}
